module.exports = __webpack_public_path__ + "static/media/Background._Registro.6d9219cf.webp";